import React from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Cell,
  ResponsiveContainer,
  Label,
  LabelList,
} from "recharts";
import useTopCoursesHook from "../hooks/TopCoursesHook";

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const Top10Courses = ({ schoolId }) => {
  const { data, loading, error } = useTopCoursesHook(schoolId);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data</div>;
  }

  // Generate an array of random colors for each bar
  const colors = data.map(() => getRandomColor());

  const maxValue = Math.max(...data.map((d) => d.Enrollment));

  return (
    <Card>
      <CardHeader
        title="Top 10 Courses"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="Course" interval={0}>
              <Label value="Course" offset={-5} position="insideBottom" />
            </XAxis>
            <YAxis
              tickFormatter={(value) => value.toLocaleString()}
              domain={[0, maxValue]}
              tickCount={10}
            >
              <Label value="# Enrolled" angle={-90} position="insideLeft" />
            </YAxis>
            <Tooltip />
            <Bar dataKey="Enrollment">
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default Top10Courses;
